import { IllustrationLogo } from '@/components/logos/IllustrationLogo';
import React from 'react';

export const Illustration = ({ title }: { title: string }) => {
  return (
    <div className="flex flex-col justify-center items-center text-center mt-[20px]">
      <IllustrationLogo />
      <p className="font-bold text-[20px]"> 
        {title} <span className="text-warning"> ergab keine Ergebnisse.</span>
      </p>
      <p className="font-normal text-[16px]">Dynamische Stromtarife, intelligentes Lastmanagement, technologische Neuerungen - viele Potentiale warten über unseren Quick-Check hinaus. Sprechen Sie uns an!</p>
    </div>
  );
};
